import "@/App.css";
import { BrowserRouter, Routes, Route, Outlet } from "react-router-dom";
import { Toaster } from "sonner";
import SmoothScroll from "@/components/site/SmoothScroll";
import { ConsentProvider } from "@/components/site/ConsentManager";
import Navbar from "@/components/site/Navbar";
import Footer from "@/components/site/Footer";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Doors from "@/pages/Doors";
import Windows from "@/pages/Windows";
import Contact from "@/pages/Contact";
import Privacy from "@/pages/Privacy";
import Cookies from "@/pages/Cookies";

function Layout() {
  return (
    <SmoothScroll>
      <div className="App flex min-h-screen flex-col bg-cream">
        <Navbar />
        <main className="flex-1">
          <Outlet />
        </main>
        <Footer />
      </div>
    </SmoothScroll>
  );
}

function App() {
  return (
    <BrowserRouter>
      <ConsentProvider>
        <Toaster position="top-center" richColors />
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/doors" element={<Doors />} />
            <Route path="/windows" element={<Windows />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/cookies" element={<Cookies />} />
          </Route>
        </Routes>
      </ConsentProvider>
    </BrowserRouter>
  );
}

export default App;
